var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 73 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 70C10.7728 70 0 59.2272 0 45.9375C0 32.6478 10.7728 21.875 24.0625 21.875C37.3522 21.875 48.125 32.6478 48.125 45.9375C48.125 59.2272 37.3522 70 24.0625 70ZM12.0312 45.9375C12.0312 49.1284 13.2988 52.1886 15.5551 54.4449C17.8114 56.7012 20.8716 57.9688 24.0625 57.9688C27.2534 57.9688 30.3136 56.7012 32.5699 54.4449C34.8262 52.1886 36.0938 49.1284 36.0938 45.9375H31.2812C31.2812 47.852 30.5207 49.6882 29.1669 51.0419C27.8132 52.3957 25.977 53.1562 24.0625 53.1562C22.148 53.1562 20.3118 52.3957 18.9581 51.0419C17.6043 49.6882 16.8438 47.852 16.8438 45.9375H12.0312Z",
    fill: "#72C0B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.125 48.125C34.8353 48.125 24.0625 37.3522 24.0625 24.0625C24.0625 10.7728 34.8353 0 48.125 0C61.4147 0 72.1875 10.7728 72.1875 24.0625C72.1875 37.3522 61.4147 48.125 48.125 48.125ZM48.125 43.3125C53.2304 43.3125 58.1267 41.2844 61.7368 37.6743C65.3469 34.0642 67.375 29.1679 67.375 24.0625C67.375 18.9571 65.3469 14.0608 61.7368 10.4507C58.1267 6.84062 53.2304 4.8125 48.125 4.8125C43.0196 4.8125 38.1233 6.84062 34.5132 10.4507C30.9031 14.0608 28.875 18.9571 28.875 24.0625C28.875 29.1679 30.9031 34.0642 34.5132 37.6743C38.1233 41.2844 43.0196 43.3125 48.125 43.3125ZM36.0938 24.0625H40.9062C40.9062 25.977 41.6668 27.8132 43.0206 29.1669C44.3743 30.5207 46.2105 31.2812 48.125 31.2812C50.0395 31.2812 51.8757 30.5207 53.2294 29.1669C54.5832 27.8132 55.3438 25.977 55.3438 24.0625H60.1562C60.1562 27.2534 58.8887 30.3136 56.6324 32.5699C54.3761 34.8262 51.3159 36.0938 48.125 36.0938C44.9341 36.0938 41.8739 34.8262 39.6176 32.5699C37.3613 30.3136 36.0938 27.2534 36.0938 24.0625Z",
    fill: "#72C0B0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.8cbe01bade7d41dc7f312ffe5652d31f.svg";
export { ForwardRef as ReactComponent };